import { Alert, Box, Button, Stack, Typography } from "@mui/material";

interface Props {
  changesLabel: string;
  hasPendingChangeRequest: boolean;
  onDiscardChanges: () => void;
  onReviewAndSubmit: () => void;
}

const UnsavedChangesAlert = ({ changesLabel, hasPendingChangeRequest, onDiscardChanges, onReviewAndSubmit }: Props) => (
  <Alert severity="warning" icon={false} sx={{ ".MuiAlert-message": { width: "100%" } }}>
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2 }}>
      <Typography>
        <strong>{changesLabel}</strong>
      </Typography>
      <Stack direction="row" spacing={1}>
        <Button variant="outlined" color="inherit" sx={{ whiteSpace: "nowrap" }} onClick={onDiscardChanges}>
          Discard Changes
        </Button>
        <Button variant="contained" color="warning" sx={{ whiteSpace: "nowrap" }} onClick={onReviewAndSubmit}>
          Review &amp; {hasPendingChangeRequest ? "Update" : "Submit"} Request
        </Button>
      </Stack>
    </Box>
  </Alert>
);

export default UnsavedChangesAlert;
